import {addEvent} from '../add-event'

export function selectFromTimePeriodEvent(
    currentTimePeriod: string,
    newTimePeriod: string,
): boolean {
    return addEvent('reportsPageSelectFromTimePeriod', {currentTimePeriod, newTimePeriod})
}
